import React, { useContext } from "react";
import TabBar, { TabBarProps } from "../../../../shared/components/TabBar"; // Adjust the import based on your project structure
import { AuthenticationContext } from "../../../../provider/AuthenticationProvider";
import { ROLE } from "../../../../data/enums";

interface MaterialTabNavigationProps {
    materialDetailTab: any;
    providerDetailTab: any;
    transactionHistoryTab: any;
    expirationManagementTab: any;
    priceStatisticsTab: any;
    outsourceStandardTab: any;
}

const DetailMaterialTabNavigation = ({
                                         materialDetailTab,
                                         providerDetailTab,
                                         transactionHistoryTab,
                                         expirationManagementTab,
                                         priceStatisticsTab,
                                         outsourceStandardTab,
                                     }: MaterialTabNavigationProps) => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);

    const tabs: TabBarProps[] = [
        {
            label: "Thông tin",
            labelEN: "info",
            content: materialDetailTab,
        },
        {
            label: "Nhà cung cấp",
            labelEN: "provider",
            content: providerDetailTab,
        },
        {
            label: "Định mức gia công",
            labelEN: "outsource-standard",
            content: outsourceStandardTab,
        },
        {
            label: "Lịch sử xuất/nhập",
            labelEN: "export-import-log",
            content: transactionHistoryTab,
        },
        {
            label: "Quản lý ngày đến hạn",
            labelEN: "expiration-management",
            content: expirationManagementTab,
        },
        {
            label: "Thống kê giá",
            labelEN: "price-statistics",
            content: priceStatisticsTab,
        },
    ];

    const getTabs = () => {
        switch (role) {
            case ROLE.SALE_MANAGER:
            case ROLE.SALE_STAFF:
                return tabs.filter(
                    (item) => item.labelEN !== "export-import-log",
                );
            case ROLE.STORAGE_KEEPER:
            case ROLE.FIRST_STORAGE_KEEPER:
                return tabs.filter(
                    (item) => item.labelEN !== "price-statistics",
                );
            case ROLE.SECOND_STORAGE_KEEPER:
                return tabs.filter(
                    (item) => item.labelEN !== "price-statistics",
                );
            case ROLE.DELIVERER:
            case ROLE.LOGISTIC_MANAGER:
            case ROLE.LOGISTIC_STAFF:
            case ROLE.PURCHASING_STAFF:
            case ROLE.PRODUCTION_STAFF:
            case ROLE.MANAGER:
            case ROLE.ACCOUNTANT_MANAGER:
            case ROLE.FACTORY_STAFF:
            case ROLE.FACTORY_MANAGER_ONE:
            case ROLE.FACTORY_MANAGER_TWO:
            case ROLE.DEPUTY_FACTORY_MANAGER_ONE:
            case ROLE.DEPUTY_FACTORY_MANAGER_TWO:
                return tabs;
            default:
                return tabs;
        }
    };

    return <TabBar tabs={getTabs()} />;
};

export default DetailMaterialTabNavigation;
